<template>
    <component :is="lazyTemplate">

        <v-card tile elevation="0">
            <v-card-title class="tit tit--lg">
                <span class="py-4 pl-4">선물조회</span>
            </v-card-title>
        </v-card>

        <v-divider/>

        <v-card v-if="ready && giftOrder?.purchase.giftStatus == '선물완료'" tile elevation="0" class="px-4">
            <template v-if="step == 0">
                <v-card-text>
                    <v-layout justify-center class="mt-4">
                        <v-img src="/images/sub/present.png" max-width="150" max-height="139" contain />
                    </v-layout>

                    <div class="tit tit--xs mt-4 text-center">
                        <div><b class="primary--text text--lighten-2">{{ giftOrder.buyer.name }}</b>님깨서 선물을 보내주셨습니다.</div>
                        <div>선물을 수락하시겠습니까?</div>
                    </div>
                </v-card-text>

                <v-sheet outlined class="mt-4">
                    <v-layout justify-center align-center class="grey lighten-4 pa-4">
                        <v-flex grow-shrink-0><v-img :src="giftOrder.purchase.product.thumb" width="128" height="128" contain /></v-flex>
                        <v-flex grow-shrink-0>
                            <div class="text-start">
                                <b v-html="giftOrder.purchase.product.name"></b>
                                <div>수량: {{ giftOrder.purchase.quantity.format() }}개</div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-sheet>

                <v-card-text class="mt-8">
                    <div class="tit tit--xs text-center">
                        <div>포인트로 받을경우 <b class="accent--text">{{ giftOrder.paymentAmount.format() }}</b> 포인트가 생성됩니다.</div>
                    </div>
                </v-card-text>

                <v-card-actions class="mt-4 pb-8">
                    <v-responsive width="100%" max-width="600" class="mx-auto">
                        <v-layout justify-center class="mx-n1">
                            <v-flex xs4 class="pa-1"><v-btn width="100%" x-large color="primary" @click="step++">선물수락</v-btn></v-flex>
                            <v-flex xs4 class="pa-1"><v-btn width="100%" x-large color="accent" @click="exchange">포인트 전환</v-btn></v-flex>
                            <v-flex xs4 class="pa-1"><v-btn width="100%" x-large outlined @click="reject">선물거절</v-btn></v-flex>
                        </v-layout>
                    </v-responsive>
                </v-card-actions>
            </template>

            <template v-else-if="step == 1">
                <v-card-title class="tit tit--xs">수취인 정보 입력</v-card-title>
                <v-card-text>
                    <v-text-field v-model="giftOrder.receiver.name" label="이름" persistent-placeholder hide-details/>

                    <v-row no-gutters align="center">
                        <v-col>
                            <v-select v-model="giftOrder.receiver.phone1" v-bind="$attrs" :items="phones" label="연락처" persistent-placeholder hide-details class="mt-4" disabled />
                        </v-col>
                        <v-icon small class="mt-4">mdi-minus</v-icon>
                        <v-col>
                            <v-text-field v-model="giftOrder.receiver.phone2" v-bind="$attrs" hide-details maxlength="4" class="mt-4" disabled />
                        </v-col>
                        <v-icon small class="mt-4">mdi-minus</v-icon>
                        <v-col>
                            <v-text-field v-model="giftOrder.receiver.phone3" v-bind="$attrs" hide-details maxlength="4" class="mt-4" disabled />
                        </v-col>
                    </v-row>

                    <v-text-field v-model="giftOrder.receiver.email" label="이메일" persistent-placeholder hide-details class="mt-4" />
                </v-card-text>

                <v-card-title class="mt-4 subtitle-2">배송지 정보 입력</v-card-title>
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" md="6" >
                            <v-text-field v-model="giftOrder.shippingAddress.postcode" v-bind="$attrs" label="우편번호" persistent-placeholder hide-details readonly @click="$refs.daumPostcode.open()" />
                        </v-col>
                    </v-row>
                    <v-row class="mx-n3">
                        <v-col cols="12" md="6" :class="{ 'pb-0': $vuetify.breakpoint.mobile }">
                            <v-text-field v-model="giftOrder.shippingAddress.address1" v-bind="$attrs" label="기본주소" persistent-placeholder hide-details readonly @click="$refs.daumPostcode.open()" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="giftOrder.shippingAddress.address2" v-bind="$attrs" label="상세주소" persistent-placeholder hide-details />
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="mt-4 pb-8">
                    <v-responsive width="100%" max-width="600" class="mx-auto">
                        <v-layout justify-center class="mx-n1">
                            <v-flex xs4 class="pa-1"><v-btn width="100%" x-large color="primary" @click="receive">선물받기</v-btn></v-flex>
                            <v-flex xs4 class="pa-1"><v-btn width="100%" x-large outlined @click="step--">이전으로</v-btn></v-flex>
                        </v-layout>
                    </v-responsive>
                </v-card-actions>
            </template>
        </v-card>

        <v-card v-else-if="ready && giftOrder?.purchase?.giftStatus == '선물받기완료'" tile elevation="0">
            <v-card-text class="pb-8">
                <v-layout justify-center class="mt-4">
                    <v-img src="/images/sub/present.png" max-width="150" max-height="139" contain />
                </v-layout>

                <div class="tit tit--xs mt-4 text-center">
                    <div><b class="accent--text">선물받기</b>가 완료되었습니다</div>
                </div>
            </v-card-text>
        </v-card>

        <v-card v-else-if="ready && giftOrder?.purchase?.giftStatus == '선물포인트전환완료'" tile elevation="0">
            <v-card-text class="pb-8">
                <v-layout justify-center class="mt-4">
                    <v-img src="/images/sub/present.png" max-width="150" max-height="139" contain />
                </v-layout>

                <div class="tit tit--xs mt-4 text-center">
                    <div><b class="accent--text">포인트 전환</b>이 완료되었습니다</div>
                </div>
            </v-card-text>
        </v-card>

        <v-card v-else-if="ready && giftOrder?.purchase?.giftStatus == '선물거절'" tile elevation="0">
            <v-card-text class="pb-8">
                <v-layout justify-center class="mt-4">
                    <v-img src="/images/sub/present.png" max-width="150" max-height="139" contain />
                </v-layout>

                <div class="tit tit--xs mt-4 text-center">
                    <div><b class="accent--text">선물거절</b>이 완료되었습니다</div>
                </div>
            </v-card-text>
        </v-card>

        <v-card v-else-if="ready" tile elevation="0">
            해당 선물은 받을 수 없습니다.
        </v-card>

        <daum-postcode ref="daumPostcode" @input="({ postcode, address }) => { giftOrder.shippingAddress.postcode = postcode; giftOrder.shippingAddress.address1 = address; }" />

        <login-dialog ref="loginDialog" />

    </component>
</template>
<script>
import api from "@/api";
import PickupItem from "@/components/client/shop/order/pickup-item.vue";
import LoginDialog from "@/components/client/login/login-dialog.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
export default {
    components: {
        PickupItem,
        LoginDialog,
        DaumPostcode
    },
    data(){
        return {
            ready: false,
            giftOrder: null,

            step: 0,

            phones: ["010", "011", "016", "017", "019"]
        }
    },
    async mounted(){
        await this.init();
    },
    methods: {
        async init(){
            let { giftOrder } = await api.v1.shop.giftOrders.get({ _id: this.$route.params._giftOrder });
            let [phone1, phone2, phone3] = giftOrder.receiver.phone?.phoneNumberFormat?.()?.split?.('-') || [];

            giftOrder.receiver = {
                ...giftOrder.receiver,
                phone1,
                phone2,
                phone3,
            };

            this.giftOrder = giftOrder;
            this.ready = true;
        },

        validate(){
            try{
                if(!this.giftOrder.receiver.name) throw new Error("수취인 이름을 입력해주세요");
                if(!this.giftOrder.receiver.email) throw new Error("수취인 이메일을 입력해주세요");
                if(!this.giftOrder.shippingAddress.postcode) throw new Error("배송지 우편번호를 입력해주세요");
                if(!this.giftOrder.shippingAddress.address1) throw new Error("배송지 기본주소를 입력해주세요");
                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },

        async receive(){
            if(this.validate()){
                await api.v1.shop.giftOrders.receive(this.giftOrder);
                await this.init();
            }
        },

        async login(){
            return new Promise((resolve, reject) => {
                if(this.logon) resolve();
                else{
                    this.$refs.loginDialog.$off();
                    this.$refs.loginDialog.$on("login", _ => resolve());
                    this.$refs.loginDialog.$on("cancel", _ => reject());
                    this.$refs.loginDialog.open();
                }
            });
        },

        async exchange(){
            if(await this.$confirm("포인트로 전환하시겠습니까?")){
                await this.login();
                await api.v1.shop.giftOrders.exchange(this.giftOrder);
                await this.init();
            }
        },

        async reject(){
            if(await this.$confirm("선물을 거절하시겠습니까?")){
                await api.v1.shop.giftOrders.reject(this.giftOrder);
                await this.init();
            }
        }
    },
    computed: {
        lazyTemplate(){
            return () => import(`@/templates/${this.$theme.pages.shop}`);
        },
        logon(){
            return !!this.$store.state.accessToken;
        }
    },
}
</script>

<style scoped>
.row + .row {
    margin-top: 0px;
}
</style>